import {
  takeLatest, call, put,
} from 'redux-saga/effects';
import api from '../../api/index';
import {
  GET_DASHBOARD_URLS, SET_DASHBOARD_URLS, DASHBOARD_URLS_REQUEST_FAILED, SENDING_DASHBOARD_URLS_REQUEST,
} from '../../types/Types';

/**
 * Call the api and dispatch data to the reducer
 * @param { Object } action Contained object data to be send to API call
 */
export function* getDashboardURL(action) {
  const { data } = action;
  delete data.dashboardListData;
  // console.log(dasboardList);
  try {
    yield put({
      type: SENDING_DASHBOARD_URLS_REQUEST,
      dasboardURLsData: '',
      isDURLsSending: true,
      isURLsSuccess: false,
      uRLsError: false,
    });
    // create an array of promises
    // const promises = dasboardList.map(dashboard => {
    //   // console.log(dashboard);
    //   data.DashboardId = dashboard.DashboardId;
    //   const requestParams = {
    //     dashboardRegion: data.dashboardRegion,
    //     identityRegion: data.identityRegion,
    //     openIdToken: data.openIdToken,
    //     DashboardId: dashboard.DashboardId,
    //     resetDisabled: data.resetDisabled,
    //     undoRedoDisabled: data.undoRedoDisabled,
    //   };
    //   return call(api.dashboard.getSessionEmbeddedUrl, requestParams);
    // });
    // // pass `promises` to all
    // const response = yield all(promises);
    // console.log(data);
    const response = yield call(api.dashboard.getSessionEmbeddedUrl, data);
    // console.log(response);
    if (response) {
      // const urlArray = response.map(url => url.EmbedUrl);
      yield put({
        type: SET_DASHBOARD_URLS,
        dasboardURLsData: response.EmbedUrl, // urlArray,
        isDURLsSending: false,
        uRLsError: false,
        isURLsSuccess: true,
      });
    } else {
      yield put({
        type: DASHBOARD_URLS_REQUEST_FAILED,
        dasboardURLsData: null,
        isDURLsSending: false,
        uRLsError: true,
        isURLsSuccess: false,
        fMsg: '',
      });
    }
  } catch (e) {
    yield put({
      type: DASHBOARD_URLS_REQUEST_FAILED,
      fMsg: e.message,
      isDURLsSending: false,
      uRLsError: true,
      isURLsSuccess: false,
      dasboardURLsData: null,
    });
  }
}

/**
 * map the dispatched action to the above function
 */
export default function* watchGetDashboardURL() {
  yield takeLatest(GET_DASHBOARD_URLS, getDashboardURL);
}
